import React from "react";
import "./HalloweenDecor.css";

/**
 * Halloween decoration for the home page submenu: corner spider webs and a
 * little spider dangling on a thread. Purely decorative (no taps blocked).
 *
 * Only shows from Oct 20 to Nov 1. To remove after Halloween, delete this
 * folder and the <HalloweenDecor /> line in HomePage.jsx.
 */
export function isHalloweenSeason(date = new Date()) {
  const month = date.getMonth(); // 0 = Jan
  const day = date.getDate();
  return (month === 9 && day >= 20) || (month === 10 && day <= 1);
}

// Quarter web drawn from the top-left corner (0,0); mirrored for the right side.
function webPath(size) {
  const spokes = 6;
  const rings = [0.32, 0.55, 0.78, 1];
  const angle = (i) => (Math.PI / 2) * (i / (spokes - 1));
  const point = (i, r) => [Math.cos(angle(i)) * r * size, Math.sin(angle(i)) * r * size];

  let d = "";
  for (let i = 0; i < spokes; i++) {
    const [x, y] = point(i, 1.08);
    d += `M0 0L${x.toFixed(1)} ${y.toFixed(1)}`;
  }
  rings.forEach((r) => {
    for (let i = 0; i < spokes - 1; i++) {
      const [x1, y1] = point(i, r);
      const [x2, y2] = point(i + 1, r);
      // Sag the thread a little toward the corner
      const [cx, cy] = point(i + 0.5, r * 0.82);
      d += `M${x1.toFixed(1)} ${y1.toFixed(1)}Q${cx.toFixed(1)} ${cy.toFixed(1)} ${x2.toFixed(1)} ${y2.toFixed(1)}`;
    }
  });
  return d;
}

const WEB_SIZE = 46;
const WEB_D = webPath(WEB_SIZE);

function Web({ side }) {
  return (
    <svg
      className={`hd-web hd-web-${side}`}
      width={WEB_SIZE + 4}
      height={WEB_SIZE + 4}
      viewBox={`0 0 ${WEB_SIZE + 4} ${WEB_SIZE + 4}`}
      aria-hidden="true"
    >
      <path d={WEB_D} fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
    </svg>
  );
}

function Spider() {
  return (
    <div className="hd-spider-drop">
      <div className="hd-thread" />
      <svg className="hd-spider" width="22" height="20" viewBox="0 0 22 20" aria-hidden="true">
        <g stroke="#1f2937" strokeWidth="1.2" fill="none" strokeLinecap="round">
          <path d="M8 8 L3 4 L1 7" />
          <path d="M8 10 L2 9 L0 12" />
          <path d="M8 12 L3 14 L1 18" />
          <path d="M9 13 L6 17 L5 20" />
          <path d="M14 8 L19 4 L21 7" />
          <path d="M14 10 L20 9 L22 12" />
          <path d="M14 12 L19 14 L21 18" />
          <path d="M13 13 L16 17 L17 20" />
        </g>
        <ellipse cx="11" cy="12" rx="4.2" ry="4.8" fill="#1f2937" />
        <circle cx="11" cy="6.5" r="2.8" fill="#1f2937" />
        <circle cx="10" cy="6.2" r="0.8" fill="#fb923c" />
        <circle cx="12" cy="6.2" r="0.8" fill="#fb923c" />
      </svg>
    </div>
  );
}

export default function HalloweenDecor() {
  if (!isHalloweenSeason()) return null;
  return (
    <div className="hd-layer" aria-hidden="true">
      <Web side="left" />
      <Web side="right" />
      <Spider />
    </div>
  );
}
